<template>
  <div v-bind:style="style" class="cutescroll">
    <b-input-group>
      <b-form-checkbox-group 
          v-model="selected"
          :options="Options"
          :style="this.columnCountStyle"
          name="flavour-2a"
          stacked 
          @change="OnChange"
          :class="UseClassFlex ? 'd-flex' :''"         
          :disabled="isReadOnly"
          :text-field="textField"
          :value-field="valueField"
          v-on:input="onInput"
        >
      </b-form-checkbox-group>
    </b-input-group>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
export default {
  name: 'MdCheckListBox2',
   props: {
     isReadOnly:    Boolean,
     value:         Array,
     TransDate:     String,
     Options:       Array,
     Tag:           String,
     isRequired:    Boolean,
     isValid:       Boolean,
     textField:     String,
     valueField:    String,
     Height:        String,
     columnCount:   Number,
     OnChangeProp:Function,
    ignoreChangedEmit: Boolean,
    UseClassFlex: Boolean
   },

  data(){
      return{
        ControlMax:1,
        selected: this.value,
        updatingFromProp: false,
        style:{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            justifyContent: 'flex-start',
            overflow:'auto',
            height: this.Height,
            padding: '5px 10px',
            border: 'solid 1px #e0e0e0 !important',
            borderRadius: '10px',
            borderColor: '#e0e0e0 !important',
            lineHeight: '1.55rem',
            color: '#666',
            fontSize: '0.875rem',
            fontWeight: '400',
        },
        columnCountStyle:this.columnCount != null ? "column-count: "+this.columnCount+"; gap: 15px;" : "column-count: 1; gap: 15px;"
      }
  },

  watch: {
    value: function (newValue) {
      this.updatingFromProp = true;
      this.selected = newValue ? newValue : [];
      this.$nextTick(() => {
        this.updatingFromProp = false;
      });
    },
    
    isValid: function (newValue) {
        this.setValid(newValue)
    }
  },

  methods:{
    OnChange(value){  
      this.$emit('change', value);    
      this.$emit('input', value);
      this.style.borderColor = value.length == 0 && this.isRequired ? '#dc3545 !important' : '#e0e0e0 !important';
     
      if (this.OnChangeProp) {
        this.OnChangeProp(value);
      }
    },

    setValid(state){
      this.style.borderColor = state && this.isRequired ? '#e0e0e0 !important' : '#dc3545 !important' 
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '#e0e0e0 !important';
      }
    },

    onInput(){
       if (this.updatingFromProp) return;
       
      var changed = {
        "Changed":true,
        "ComponentName":this.Label,
        "Tag": this.Tag
      }
       
       if (!this.ignoreChangedEmit){
          EventBus.$emit('onChanged', changed);
       }
        
    }
  },

  mounted(){   
  }
};
</script>


